import { Image } from 'react-native';

import LightImages from '../Light/Images';

const _images = {
  ...LightImages,

  ic_close: Image.resolveAssetSource(require('./../../../Assets/Images/Icons/icCloseWhite@3x.png')),
  ic_arrow_left: Image.resolveAssetSource(
    require('./../../../Assets/Images/Icons/icArrowLeftWhite@3x.png'),
  ),
  ic_refresh: Image.resolveAssetSource(require('../../../Assets/Images/Icons/icRefreshWhite@3x.png')),
  ic_bold_small_refresh: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icRefreshWhite@3x.png'),
  ),
  ic_top_up: Image.resolveAssetSource(require('../../../Assets/Images/Icons/icTopUpWhite@3x.png')),
  ic_chevron_right_red: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icChevronRightOrange@3x.png'),
  ),
  ic_chevron_right: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icChevronRightWhite@3x.png'),
  ),
  ic_rewards: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icAllRewardsWhite@3x.png'),
  ),
  ic_wifi_broadband: Image.resolveAssetSource(
    require('./../../../Assets/Images/Icons/icWifiBroadbandWhite@3x.png'),
  ),
  ic_bills: Image.resolveAssetSource(
    require('./../../../Assets/Images/Icons/ic_bill_report_generic_tariff_plan_white@3x.png'),
  ),
  ic_admin: Image.resolveAssetSource(require('./../../../Assets/Images/Icons/ic_admin_white@3x.png')),
  ic_sim: Image.resolveAssetSource(require('./../../../Assets/Images/Icons/icSimWhite@3x.png')),
  ic_warning_mid: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/ic_warning_mid@3x.png'),
  ),
  icLocation: Image.resolveAssetSource(require('../../../Assets/Images/Icons/icLocationDark@3x.png')),
  icCallsContacts: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icCallsContactsDark@3x.png'),
  ),
  ic_Notification: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icNotificationDark@3x.png'),
  ),
  icNetworkMap: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icNetworkMapDark@3x.png'),
  ),
  ic_Users_Members_Customers: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icUsersMembersCustomersDark@3x.png'),
  ),
  ic_Landline_Or_Call_Minutes: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/ic_landline_or_call_minutesDark@3x.png'),
  ),
  ic_RefreshRed: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icRefreshDark.png'),
  ),
  ic_pin_pad: Image.resolveAssetSource(require('../../../Assets/Images/Icons/call_log@3x.png')),
  ic_chevron_down_orange: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icChevronDownOrange@3x.png'),
  ),
  ic_chevron_up_orange: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icChevronUpOrange@3x.png'),
  ),
  ic_chevron_up_white: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icChevronUp@3x.png'),
  ),
  ic_tick_solved_lemon: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icTickSolvedLemon@3x.png'),
  ),
  ic_hide_password: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/ic_hide_password_white@3x.png'),
  ),
  ic_show_password_insights: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icShowPasswordInsightsWhite@3x.png'),
  ),
  ic_warning_mid_active: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/ic_warning_notification_white@3x.png'),
  ),
  ic_warning: Image.resolveAssetSource(require('../../../Assets/Images/Icons/ic_warning_mid@3x.png')),
  ic_WarningHiLight_Theme: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icWarningHiDarkTheme@3x.png'),
  ),
  header_image_overlay: Image.resolveAssetSource(
    require('../../../Assets/Images/HeaderOverlays/darkOverlay@3x.png'),
  ),
  icPadlockClose: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/ic_security_white@3x.png'),
  ),
  ic_mobile: Image.resolveAssetSource(require('../../../Assets/Images/Icons/ic_mobileDark@3x.png')),
  ic_v_home_monitor: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icVHomeMonitorDark@3x.png'),
  ),
  ic_alarm_assistant: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icAlarmAssistantDark@3x.png'),
  ),
  ic_video_cloud: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icVideoCloud@3x.png'),
  ),
  ic_mobiles: Image.resolveAssetSource(require('../../../Assets/Images/Icons/icMobilesDark@3x.png')),
  ic_chevron_down: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icChevronDownWhite2@3x.png'),
  ),
  ic_tick_solved: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icTickSolvedWhite@3x.png'),
  ),
  icInfoCircle: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/ic_info_circle_white@3x.png'),
  ),
  ic_indicators_admin: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icAdminWhite@3x.png'),
  ),
  ic_indicators_business: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/iconsIndicatorsSystemIconsBusinessFfffff@3x.png'),
  ),
  ic_indicators_home: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icHomeWhite@3x.png'),
  ),
  ic_indicators_family: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icFamilyWhite@3x.png'),
  ),
  ic_close_circle: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icCloseCircleDark@3x.png'),
  ),
  ic_close_circle_white: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icCloseCircleWhite@3x.png'),
  ),
  ic_user: Image.resolveAssetSource(require('../../../Assets/Images/Icons/icUser@3x.png')),
  ic_share: Image.resolveAssetSource(require('../../../Assets/Images/Icons/icShareWhite@3x.png')),
};

const TImages = {
  ...LightImages.TImages,

  VFLogo: {
    primary: { ...LightImages.logo_vf_white },
    secondary: { ...LightImages.logo_vf_white },
  },
  ic_close: {
    primary: LightImages.ic_close_white,
    secondary: LightImages.ic_close_white,
  },
  ic_chevron_down: {
    primary: _images.ic_chevron_down,
    secondary: _images.ic_chevron_down,
  },
  ic_chevron_up: {
    primary: _images.ic_chevron_up_white,
    secondary: _images.ic_chevron_up,
  },
  ic_tick_solved: {
    primary: _images.ic_tick_solved_lemon,
    secondary: _images.ic_tick_solved,
  },
};
const images = { ..._images, TImages };

export default images;
